import { useTranslation } from 'react-i18next';

import {
    Box,
    IconChevronRight,
    Subtitle1,
    TextButton,
} from '@myphx-engineering/phx-design-system';
import { ContactBookIllustration, IllustrationCard } from '@phx/myphx-lib';
import { usePwaContext } from '@phx/pwa';

export const AddContactCard = () => {
    const { t } = useTranslation();
    const { addContact } = usePwaContext();

    return (
        <IllustrationCard
            Illustration={ContactBookIllustration}
            variant="filled"
            color="error"
            header={<Subtitle1>{t('home.addContactCard.heading')}</Subtitle1>}
            onClick={addContact}
            // oxlint-disable-next-line jsx-a11y/role-has-required-aria-props -- tracked in docs/oxlint-violations.md
            role="tab"
        >
            <Box>
                <TextButton RightIcon={IconChevronRight}>
                    {t('home.addContactCard.button')}
                </TextButton>
            </Box>
        </IllustrationCard>
    );
};
